import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import AnalyzePage from "./pages/AnalyzePage";
import ReportPage from "./pages/ReportPage";

import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SignupPage from "./pages/SignupPage";
import DashboardPage from "./pages/DashboardPage";
import SettingsPage from "./pages/SettingsPage";
import PricingPage from "./pages/PricingPage";
import AnalysesPage from "./pages/AnalysesPage";
import ActionPlanPage from "./pages/ActionPlanPage";
import ChatPage from "./pages/ChatPage";
import BacklinkOpportunitiesPage from "./pages/BacklinkOpportunitiesPage";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./components/DashboardLayout";
import AuthAwareDashboardLayout from "./components/AuthAwareDashboardLayout";
import NotFound from "./pages/NotFound";
import FreeAuditToolPage from "./pages/landing/FreeAuditToolPage";
import UnsubscribePage from "./pages/UnsubscribePage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/analyze" element={<AuthAwareDashboardLayout><AnalyzePage /></AuthAwareDashboardLayout>} />
          <Route path="/report" element={<AuthAwareDashboardLayout><ReportPage /></AuthAwareDashboardLayout>} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout><DashboardPage /></DashboardLayout></ProtectedRoute>} />
          <Route path="/analyses" element={<ProtectedRoute><DashboardLayout><AnalysesPage /></DashboardLayout></ProtectedRoute>} />
          <Route path="/action-plan" element={<ProtectedRoute><DashboardLayout><ActionPlanPage /></DashboardLayout></ProtectedRoute>} />
          <Route path="/chat" element={<ProtectedRoute><DashboardLayout><ChatPage /></DashboardLayout></ProtectedRoute>} />
          <Route path="/backlink-opportunities" element={<ProtectedRoute><DashboardLayout><BacklinkOpportunitiesPage /></DashboardLayout></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><DashboardLayout><SettingsPage /></DashboardLayout></ProtectedRoute>} />
          <Route path="/tools/free-seo-audit" element={<FreeAuditToolPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
